module.exports = __webpack_public_path__ + "static/Banner-23-861009b09203497a1d47aeb6016ef8d7.png";